<script lang="ts">
  import { ResponsiveVars } from '@twist/core';
  import { cx } from '@emotion/css';
  import BlockButton from '$components/Button/BlockButton.svelte';
  import ArrowRight from '$components/Icons/ArrowRight.svelte';
  import { toFluidVarInput } from '$lib/utils/fluidity';
  import { flagValue } from '$lib/context/flags';
  import { FEATURE_FLAGS } from '$lib/flags/constants';

  const responsiveVars = new ResponsiveVars()
    .addFluid('apply-text-gap', toFluidVarInput(6, 6))
    .addFluid('apply-icon-size', toFluidVarInput(12, 12))
    .toCSS();

  $: brandReskinEnabled = flagValue(FEATURE_FLAGS.BRAND_RESKIN);
</script>

<BlockButton
  fullWidth
  fontSize={brandReskinEnabled ? undefined : toFluidVarInput(12, 16)}
  on:click
  data-dd-action-name="Apply button"
>
  <div class={cx(responsiveVars, 'apply-text')}>
    Apply

    <div class="apply-icon">
      <ArrowRight />
    </div>
  </div>
</BlockButton>

<style>
  .apply-text {
    display: flex;
    align-items: center;
    gap: var(--apply-text-gap);
  }

  .apply-icon {
    display: flex;
    width: var(--apply-icon-size);
    height: var(--apply-icon-size);
  }
</style>
